"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBAPIDocsMenu;
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _SubMenus = _interopRequireDefault(require("./js/SubMenus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
 * SVB API DOcs Menu
 * Author by Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * <SVBAPIDocsMenu data={data} apiStatus={apiStatus} />
 */

/**
 * >SVBAPIDocsMenu
 * @param data: json array of side-nav objs
 * see ../readme.MD for sample body
 * @param apiStatus: json obj for api operational status
 * see ../readme.MD for sample body
 * @param extraClasses: additional styling classes
 * @returns APIdocs side nav menu HTML with content
 * @handleCallback function would result of the item that we selected
 */
function SVBAPIDocsMenu(props) {
  const {
    data,
    apiStatus,
    extraClasses,
    overrideToggle = false,
    external = false
  } = props;
  const [slideToggle, setSlideToggle] = (0, _react.useState)(true);
  const [open, setOpen] = (0, _react.useState)(false);
  const [selectedParentId, setSelectedParentId] = (0, _react.useState)(null);
  const [selectedId, setSelectedId] = (0, _react.useState)(null);
  const mobileProps = props.mobileProps;
  const onhandleChange = props.onhandleChange;
  const onChange = (0, _react.useCallback)(item => {
    setSelectedId(Number(item.id) === selectedId ? null : Number(item.id));
    if (typeof props.handleMenuCallback === 'function') {
      props.handleMenuCallback(item);
    }
  });
  (0, _react.useEffect)(() => {
    if (props.selectedParentId) {
      setSelectedParentId(Number(props.selectedParentId));
    }
    if (props.selectedID) {
      setSelectedId(props.selectedID);
    }
  }, [props.selectedID]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: mobileProps ? "svb-mobile-sidemenu svb-api-docs-sidebar ".concat(extraClasses ? extraClasses : '').concat(slideToggle ? 'inactive' : '') : "svb-api-docs-sidebar ".concat(extraClasses ? extraClasses : '').concat(slideToggle ? 'inactive' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slide-toggle",
    onClick: () => setSlideToggle(!slideToggle)
  }, slideToggle ? /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-align-justify"
  }, " ") : /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-outdent"
  }, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: open ? 'mobile-header open' : 'mobile-header',
    onClick: () => setOpen(!open)
  }, /*#__PURE__*/_react.default.createElement("span", null, "API Docs"), /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-solid fa-chevron-down bi-chevron-down toggle-btn",
    onClick: () => setOpen(!open)
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: mobileProps ? 'sidebar-nav sidebar-mobile-nav' : open ? 'vh-100 sidebar-nav open' : 'vh-100 sidebar-nav'
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "sidebar-nav-items"
  }, data.map((item, index) => /*#__PURE__*/_react.default.createElement(_SubMenus.default, {
    key: index,
    external: external,
    overrideToggle: overrideToggle,
    item: item,
    itemid: index,
    handleCallback: e => onChange(e),
    selectedId: selectedId,
    selectedParentId: selectedParentId,
    onhandleChange: onhandleChange
  })))), apiStatus && apiStatus.type && /*#__PURE__*/_react.default.createElement("div", {
    className: open ? 'sidebar-footer open' : 'sidebar-footer'
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: apiStatus.link,
    className: "d-flex indicator indicator--".concat(apiStatus.type)
  }, apiStatus.status)));
}